import { markAllCompleted, markAllSkipped } from 'resources/task/workflows/markSkippedOrCompleted';

import * as dealOperations from 'resources/deal/deal.operations';

import { COMPLETE_MODE_TYPES } from 'resources/deal/deal.constants';

const processTasks = async ({ tasks, mode }) => {
  if (mode === COMPLETE_MODE_TYPES.MARK_ALL_COMPLETED) {
    return markAllCompleted(tasks);
  }

  if (mode === COMPLETE_MODE_TYPES.MARK_ALL_SKIPPED) {
    return markAllSkipped(tasks);
  }
};

export const completeTransaction = async ({
  deal, tasksToComplete, mode, userId,
}) => {
  await processTasks({ tasks: tasksToComplete, mode });

  await dealOperations.actualizeTransactionStatus(deal, userId);

  return deal;
};
